export const OwnerEnumInformation = {
  1: 'PLAYER_1',
  2: 'PLAYER_2',
  3: 'PLAYER_3',
  4: 'PLAYER_4',
  5: 'PLAYER_5',
  6: 'PLAYER_6',
  7: 'PLAYER_7',
  8: 'PLAYER_8',
  0: 'NO_OWNER'
}
